import { format, unwrapFunctionStore } from 'svelte-i18n';

import { campaignsSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const dashboardHeader = {
  element: '#campaigns > thead > tr',
  popover: {
    title: 'Campaigns Dashboard',
    description:
      'Manage your campaigns effortlessly! Click the <strong>&quot;Status&quot;</strong> column header to sort and organize your campaigns. ',
    side: 'bottom',
    align: 'end'
  }
};

export const dashboardRow = {
  element: '#campaigns > tbody > tr:nth-child(1)',
  popover: {
    title: 'Managing a Campaign',
    description:
      'Every campaign item is packed with everything you need! View the campaign creative, explore detailed info, track performance metrics, check the current status, and take quick actions—all in one place.',
    side: 'bottom',
    align: 'center'
  }
};

export const dashboardCreative = {
  element: '#campaigns > tbody > tr:nth-child(1) > td:nth-child(1)',
  popover: {
    title: 'Campaign Creative',
    description:
      'The creative gives you a sneak peek of the campaign! Click on it to jump straight into the <strong>Campaign Editor</strong>.',
    side: 'bottom',
    align: 'center'
  }
};

export const dashboardCampaign = {
  element: '#campaigns > tbody > tr:nth-child(1) > td:nth-child(2)',
  popover: {
    title: 'Campaign Details',
    description:
      'Check out key campaign details like the campaign name, schedule, and any associated tags or categories!',
    side: 'bottom',
    align: 'center'
  }
};

export const dashboardPerformance = {
  element: '#campaigns > tbody > tr:nth-child(1) > td:nth-child(3)',
  popover: {
    title: 'Campaign Performance',
    description: "Easily track your campaign's performance with key metrics like deliveries, impressions, and clicks!",
    side: 'bottom',
    align: 'center'
  }
};

export const dashboardStatus = {
  element: '#campaigns > tbody > tr:nth-child(1) > td:nth-child(4)',
  popover: {
    title: 'Campaign Status',
    description:
      "Quickly check your campaign's status! If it's <code><strong>ACTIVE</strong></code>, hover over the status for more context.",
    side: 'bottom',
    align: 'center'
  }
};

export const dashboardActions = {
  element: '#campaigns > tbody > tr:nth-child(1) > td:nth-child(5)',
  popover: {
    title: 'Campaign Actions',
    description:
      'Access campaign actions like <strong>Edit</strong>, <strong>Clone</strong>, and <strong>Export Clicks</strong> by clicking the <code><i class="os-icon-more-vertical"></i></code> button.',
    side: 'bottom',
    align: 'center',
    onNextClick: () => {
      campaignsSettingsStore.update((campaigns) => {
        return {
          ...campaigns,
          tours: {
            ...campaigns.tours,
            overviewHasToured: true
          }
        };
      });

      GLOBAL_DRIVER_OBJECT.destroy();
    }
  }
};
